export default "/_next/static/fonts/Kalam.831aaad03890ba2d7417335781281371.ttf";